import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GaugeUi from '../../ui/homeUi/GaugeUi';
import OrderCardsUi from '../../ui/homeUi/orderCardsUi';
import OrderChartsUi from '../../ui/homeUi/orderChartsUi';
import AdCardsUi from '../../ui/homeUi/adCardsUi';
import AdMostUi from '../../ui/homeUi/adMostUi';
import AdDountsUi from '../../ui/homeUi/adDountsUi';
import AdChartsUi from '../../ui/homeUi/adChartsUi';
import UserCardsUi from '../../ui/homeUi/userCardsUi';
import UserMostUi from '../../ui/homeUi/userMostUi';
import UserChartsUi from '../../ui/homeUi/userChartsUi';
import CategoryCardsUi from "../../ui/homeUi/categoryCardsUi";
import CategoryMostUi from "../../ui/homeUi/categoryMostUi";
// import { GetActiveAdsByTimeData, GetHomeData, GetRevenueByTimeData, GetUserByHoursData, GetVisitByHoursData } from '../../lib/data';
import { GetHomeData } from '../../lib/data';
import { useDispatch } from 'react-redux';
// import { statisticsActions } from "../../lib/stores/statistics";

export default function Home () {

    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const [data, setData] = useState([]);
    const dispatch = useDispatch();


    useEffect(() => {
        handleData();
    }, [])

    const handleData = async () => {
        const result = await GetHomeData();
        setData(result.data);
        // dispatch(statisticsActions.addItemToList(result.data));
    };

    // const handleOrderChartFilters = async ({ year, month }) => {

    //     let params = year ? [{"year" : year}, {"type" : "month"}] : [{"month" : month}, {"type" : "day"}];

    //     if (params) {
    //         const result = await GetRevenueByTimeData(params);
    //         params = [];

    //         setData(prevData => ({
    //             ...prevData,
    //             revenue_by_time: result.data 
    //         }));
    //     };
    // };

    // const handleAdChartFilters = async ({ year, month }) => {

    //     let params = year ? [{"year" : year}, {"type" : "month"}] : [{"month" : month}, {"type" : "day"}];

    //     if (params) {
    //         const result = await GetActiveAdsByTimeData(params);
    //         params = [];

    //         setData(prevData => ({
    //             ...prevData,
    //             active_ad_by_time: result.data 
    //         }));
    //     };
    // };

    // const handleUserChartFilters = async (chartType, params) => {

    //     if (chartType === "activity") {

    //         let param = params ? [{"month" : params.range}] : "";

    //         if(param){
    //             const result = await GetVisitByHoursData(param);
    
    //             setData(prevData => ({
    //                 ...prevData,
    //                 visit_by_hours: result.data 
    //             }));
    //         };
    //     }
        
    //     else if (chartType === "growth") {

    //         let param = params.year ? [{"year" : params.year}, {"type" : "month"}] : [{"month" : params.month}, {"type" : "day"}];

    //         if (param) {
    //             const result = await GetUserByHoursData(params);
    //             param = [];

    //             setData(prevData => ({
    //                 ...prevData,
    //                 user_by_time: result.data 
    //             }));
    //         };
    //     }
    // };



    return(<>
        <div className='px-8 py-5'>
{/* 
            <div className='chart-wrap w-full p-1 grid lg:grid-cols-4 xs:grid-cols-1 sm:grid-cols-2 gap-10 justify-center items-center my-4 rounded-lg'>
                <GaugeUi value={data} />
            </div> */}
            <OrderCardsUi value={data} />
            <div className='grid grid-cols-2 justify-center items-center gap-6'>
                <OrderChartsUi value={data} />
                <AdChartsUi value={data} />
                {/* <OrderChartsUi value={data} onFilterChange={handleOrderChartFilters}/> */}
            </div>

            {/* <div className='border-b border-gray-500 w-4/5 mx-auto flex justify-center items-center text-white'><h1 className='relative top-[12px]'>Ads</h1></div> */}
                {/* <AdCardsUi value={data} /> */}
            {/* <div> */}
                {/* <AdMostUi value={data} /> */}
            {/* </div> */}
            {/* <div className='flex flex-col md:flex-row md:justify-between md:items-center my-5 gap-6'> */}
                {/* <AdDountsUi value={data} /> */}
            {/* </div> */}
            {/* <div className='chart-wrap w-full bg-thirdly flex flex-col justify-center gap-3 px-7 pt-7 mb-7 pb-2 my-4 rounded-lg'> */}
                {/* <AdChartsUi value={data} onFilterChange={handleAdChartFilters}/> */}
            {/* </div> */}

            <div className='border-b border-gray-500 w-4/5 mx-auto flex justify-center items-center text-white'><h1 className='relative top-[12px]'>Users</h1></div>
            <UserCardsUi value={data} />
            <div>
                <UserMostUi value={data} />
            </div>
            <div className='grid grid-cols-2 justify-center items-center gap-6'>                
                {/* <UserChartsUi value={data} /> */}
                {/* <UserChartsUi value={data} onFilterChange={handleUserChartFilters} /> */}
            </div>

            <div className='border-b border-gray-500 w-4/5 mx-auto flex justify-center items-center text-white'><h1 className='relative top-[12px]'>Categories</h1></div>
            <CategoryCardsUi value={data} />
            <div>
                <CategoryMostUi value={data} />
            </div>
        </div>
    </>);
};